module.exports = __webpack_public_path__ + "img/fruit-raspberries-350x184.5c8cdd26.jpg";